var _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEparts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 434 89",
    style: {
      enableBackground: "new 0 0 434 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D1D1B;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:#464B5D;}\r\n\t.st2{fill:#F07E25;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.9-35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.6-35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,25.5h41.9V14.3H32.2c-18,0-21.8,9.6-21.8,17.7v24.2c0,8.1,3.8,17.7,21.8,17.7h41.9V62.7H32.2 c-9.4,0-10.5-3.7-10.5-6.5v-6.5h52.4V38.5H21.7V32C21.7,29.2,22.8,25.5,32.2,25.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.3,14.3H84.4v11.2h41.9c9.4,0,10.5,3.7,10.5,6.5c0,2.8-1.1,6.5-10.5,6.5H84.4v35.4h11.2V49.7h30.7 c18,0,21.8-9.6,21.8-17.7S144.3,14.3,126.3,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.4,14.3h-20.2c-18,0-21.8,9.6-21.8,17.7v41.9h11.2V53.8h41.2v20.2h11.2V32 C218.1,23.9,214.3,14.3,196.4,14.3z M206.9,32v10.5h-41.2V32c0-2.8,1.1-6.5,10.5-6.5h20.2C205.8,25.5,206.9,29.2,206.9,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.8,32c0-8.1-3.8-17.7-21.8-17.7h-41.9v11.2H267c9.4,0,10.5,3.7,10.5,6.5c0,2.8-1.1,6.5-10.5,6.5h-41.9 v35.4h11.2V49.7h16.3l24.2,24.2h15.9l-24.2-24.2C285.2,49.2,288.8,39.9,288.8,32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "293.3,25.5 319.6,25.5 319.6,73.9 330.8,73.9 330.8,25.5 357,25.5 357,14.3 293.3,14.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M382.2,25.6h41.9V14.3h-41.9c-18,0-21.8,9.6-21.8,17.7s3.8,17.7,21.8,17.7h22.3c7.5,0.5,8.4,3.9,8.4,6.4 c0,2.8-1.1,6.5-10.5,6.5h-41.9v11.2h41.9c18,0,21.8-9.6,21.8-17.7c0-8.1-3.8-17.7-21.8-17.7h-22.3c-7.5-0.5-8.4-3.9-8.4-6.4 C371.7,29.3,372.8,25.6,382.2,25.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEparts);
export default __webpack_public_path__ + "static/media/logo-eparts.f52f1c4538185c16154bf742df11684b.svg";
export { ForwardRef as ReactComponent };